import { Dialog_default } from "./chunk-Y7YZLCEB.js";
import { Dialog_Backdrop_default } from "./chunk-3JOBK474.js";
import { Dialog_Content_default } from "./chunk-NXKVYDCI.js";
import { Dialog_Front_default } from "./chunk-T3R7FYDN.js";
import { Dialog_Header_default } from "./chunk-GDBX6UCI.js";
import { Dialog_Panel_default } from "./chunk-P6FCE5ET.js";

// src/components/Dialog/index.ts
var DialogComponent = Dialog_default;
DialogComponent.Backdrop = Dialog_Backdrop_default;
DialogComponent.Backdrop.displayName = "Dialog.Backdrop";
DialogComponent.Content = Dialog_Content_default;
DialogComponent.Content.displayName = "Dialog.Content";
DialogComponent.Front = Dialog_Front_default;
DialogComponent.Front.displayName = "Dialog.Front";
DialogComponent.Panel = Dialog_Panel_default;
DialogComponent.Panel.displayName = "Dialog.Panel";
DialogComponent.Header = Dialog_Header_default;
DialogComponent.Header.displayName = "Dialog.Header";
export { DialogComponent };